import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import './FixedIncomeFlowHistoryPage.css';

const FixedIncomeFlowHistoryPage = ({ user }) => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const hasFixedIncome = (user?.available_data_types || []).includes('fixed-income');

  const loadHistory = useCallback(async () => {
    if (!hasFixedIncome) {
      setEvents([]);
      setError('');
      return;
    }

    setLoading(true);
    setError('');
    try {
      const token = localStorage.getItem('authToken') || sessionStorage.getItem('authToken');
      const response = await axios.get('/api/user/fixed-income/flow-history', {
        params: { limit: 300 },
        headers: { Authorization: `Bearer ${token}` },
      });
      setEvents(Array.isArray(response.data?.events) ? response.data.events : []);
    } catch (e) {
      console.error('Error loading fixed income flow history:', e);
      setEvents([]);
      setError('Fixed Income 입출금 기록을 불러오지 못했습니다.');
    } finally {
      setLoading(false);
    }
  }, [hasFixedIncome]);

  useEffect(() => {
    loadHistory();
  }, [loadHistory]);

  const formatDateOnly = (value) => {
    if (!value) return '-';
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return '-';
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  };

  const formatAmount = (event) => {
    const raw = Number(event?.flow_amount || 0);
    if (!Number.isFinite(raw)) return '-';
    const amount = Math.abs(raw);
    const decimals = event?.flow_asset === 'KRW' ? 2 : 8;
    const formatted = amount.toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: decimals,
    });
    return `${formatted} ${event?.flow_asset || ''}`.trim();
  };

  return (
    <div className="fixed-income-flow-page">
      <div className="fixed-income-flow-header">
        <h1>History</h1>
      </div>

      {!hasFixedIncome ? (
        <div className="fixed-income-flow-empty">Fixed Income 상품이 없어 입출금 기록이 없습니다.</div>
      ) : error ? (
        <div className="fixed-income-flow-error">{error}</div>
      ) : (
        <div className="fixed-income-flow-table-wrap">
          <table className="fixed-income-flow-table">
            <thead>
              <tr>
                <th>날짜</th>
                <th>타입</th>
                <th>상품</th>
                <th>금액</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="4" className="center-cell">입출금 기록을 불러오는 중입니다...</td>
                </tr>
              ) : events.length === 0 ? (
                <tr>
                  <td colSpan="4" className="center-cell">입출금 기록이 없습니다.</td>
                </tr>
              ) : (
                events.map((event) => (
                  <tr key={`${event.history_id}-${event.created_at}`}>
                    <td>{formatDateOnly(event.created_at)}</td>
                    <td>
                      <span className={`flow-badge ${event.flow_type === 'withdrawal' ? 'withdrawal' : 'deposit'}`}>
                        {event.flow_type === 'withdrawal' ? '출금' : '입금'}
                      </span>
                    </td>
                    <td>{event.product || '-'}</td>
                    <td>{formatAmount(event)}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default FixedIncomeFlowHistoryPage;
